"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { SelectContent as t } from "../../atoms/Select/Select.mjs";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/molecules/MediaSelect/MediaSelectContent.tsx
var r = ({ className: r, children: i, ...a }) => /* @__PURE__ */ n(t, {
	className: e("dark:bg-neutral-dark-200 rounded-3xl py-4 min-w-50", r),
	...a,
	children: i
});
//#endregion
export { r as MediaSelectContent };
